import { useState } from 'react';
import { PropertyList } from '@/components/properties/PropertyList';
import { PropertyFormModal } from '@/components/properties/PropertyFormModal';

export default function Properties() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <PropertyList onAddProperty={() => setModalOpen(true)} />
      <PropertyFormModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
}
